<template lang="pug">
footer.footer
  .container-fluid-
    .footer-bar
      .container
        .col-md-12
          nav.text-right
            ul
              li
                a(href='https://www.eved.com/privacy-policy/' target='_blank') {{ $t('Privacy Policy') }}
              li
                a(href='https://www.eved.com/terms-of-use/' target='_blank') {{ $t('Terms of Use') }}
              li
                a(href='https://www.eved.com/about-us/' target='_blank') {{ $t('About Us') }}
              li
                a(href='https://www.eved.com/contact-us/' target='_blank') {{ $t('Contact Us') }}
              //- li |
              //- li
                a.lang(v-for='(lang, key) in langs', :class='{ "active": isLang(key) }', href='#', @click.prevent='setLang(key)') {{ lang }}
        .col-md-12
          p.copyright
            | Copyright ©2007-{{year}} Eved LLC.
            | All Rights Reserved. (US Patent No.: US 9,734,467 B2).
            | EvedPay Visa® Prepaid Card Solutions are hosted by
            | PEX, Prepaid Expense Solutions, and are issued by Fifth Third Bank, N.A.,
            | Member FDIC, or The Bancorp Bank, N.A., Member FDIC, pursuant to a license
            | from Visa U.S.A. Inc. and may be used everywhere Visa prepaid cards are accepted.
            | <br />
            | Please see the back of your card for its issuing bank.
</template>
<script>

import {languages, isLang, loadLanguageAsync} from '@/lang/lang'

export default {
  data() {
    return {
      year: new Date().getFullYear(),
      langs: languages
    }
  },
  methods: {
    isLang,
    setLang(lang) {
      loadLanguageAsync(lang)
    }
  }
}
</script>
<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.footer-bar {
  overflow: hidden;
  clear: both;
  padding: 15px 0;
  @include theme {
  border-top: 1px solid v(background-light);
  background: v(canvas);
  }
}

.footer {
  &.visible {
    margin-top: -8.3rem;
  }
}

.footer .heart,
.theme .footer .lang.active,
.theme .footer .lang.active:focus {
  color: $secondary-01;
}

.footer .copyright {
  margin-top: 14px;
}

@include media('<tablet') {
  .footer nav {
    margin-top: -1em;
    margin-bottom: 2em;
  }
  .footer .copyright {
    float: right !important;
    margin-top: 2em;
    margin-bottom: -4em;
    width: 100%;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Footer/index.vue